module.exports = __webpack_public_path__ + "img/banner-2-4.9735e743.png";